export default () => ({
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  linkButton: {
    background: 'none!important',
    border: 'none',
    padding: '0!important',
    fontFamily: 'arial, sans-serif',
    color: '#069',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  dimmed: {
    backgroundColor: '#F5F5F5',
  },
});
